import { Card, Col, Row, Tag } from "antd";
import { FieldTimeOutlined } from "@ant-design/icons";
import flexibleFormat from "../../functions/flexibleFormat";

/** Card component with that compares two quantities and a goal/limit */
export const YoYCard = (props) => {
  const {
    title,
    precision,
    unit,
    loading,
    currentQuantity,
    goalQuantity,
    previousQuantity,
  } = props;

  const comparison = flexibleFormat(
    previousQuantity
      ? ((currentQuantity - previousQuantity) / previousQuantity) * 100
      : 0,
  );

  const tag = () => {
    let tagColor = "red";
    let tagText = "Warning";
    if (comparison > 0 || currentQuantity > goalQuantity) {
      tagColor = "red";
      tagText = "Warning";
    } else {
      tagColor = "green";
      tagText = "Good";
    }

    return (
      <Tag
        color={tagColor}
        style={{
          height: "100%",
          width: "100%",
          textAlign: "center",
          padding: "2px 5px",
        }}
      >
        <h5 style={{ margin: "0px", fontSize: "17.6px" }}>{tagText}</h5>
      </Tag>
    );
  };

  return (
    <Card
      size="small"
      title={
        <Row>
          <Col span={12}>
            <h5 style={{ margin: "0px", fontSize: "17.6px" }}>{title}</h5>
          </Col>
        </Row>
      }
      extra={<Col span={24}>{tag()}</Col>}
      style={{ width: "100%" }}
      loading={loading}
    >
      <Row
        style={{
          height: "9%",
          width: "100%",
          padding: "3px 10px",
          textAlign: "right",
          display: loading ? "none" : "flex",
        }}
      >
        <Col span={12}>
          <Row
            style={{
              width: "100%",
              textAlign: "right",
              justifyContent: "left",
            }}
          >
            <span
              style={{
                margin: "0px",
                fontSize: "12px",
                fontWeight: "500",
                paddingLeft: "2px",
              }}
            >
              Current
            </span>
          </Row>
        </Col>
        <Col span={12} style={{ width: "100%" }}>
          <Row
            style={{
              width: "100%",
              textAlign: "right",
              justifyContent: "left",
            }}
          >
            <h5
              style={{ margin: "0px", fontSize: "12px", paddingRight: "5px" }}
            >
              Upper Limit
            </h5>
            <h5 style={{ margin: "0px", fontSize: "12px" }}>
              <FieldTimeOutlined />
            </h5>
          </Row>
        </Col>
      </Row>
      <Row
        style={{
          width: "100%",
          padding: "8px 10px",
          paddingBottom: "0px",
          textAlign: "left",
          display: loading ? "none" : "flex",
        }}
      >
        <Col span={12}>
          <h2 style={{ margin: "0px", fontSize: "26px", fontWeight: "600" }}>
            {flexibleFormat(currentQuantity, precision)}
            <span style={{ margin: "0px", fontSize: "13px" }}>{unit}</span>
          </h2>
        </Col>
        <Col span={12}>
          <h2 style={{ margin: "0px", fontSize: "26px", fontWeight: "600" }}>
            {flexibleFormat(goalQuantity, precision)}
            <span style={{ margin: "0px", fontSize: "13px" }}>{unit}</span>
          </h2>
        </Col>
      </Row>
      <Row
        style={{
          width: "100%",
          padding: "0px 10px",
          paddingBottom: "8px",
          marginTop: "-8px",
          textAlign: "left",
          display: loading ? "none" : "flex",
        }}
      >
        <Col span={12}>
          <h5
            style={{
              margin: "0px",
              fontSize: "17.6px",
              color: comparison <= 0 ? "#10c4a1" : "#e27676",
            }}
          >
            {comparison !== "0" ? (
              <>
                YoY {comparison > 0 ? "+" : ""}
                {isNaN(comparison) ? 0 : comparison}
                {"%"}
              </>
            ) : (
              <>&nbsp;</>
            )}
          </h5>
        </Col>
        <Col span={12} style={{ width: "100%" }}>
          <Row
            style={{
              width: "100%",
              textAlign: "right",
              justifyContent: "right",
            }}
          ></Row>
        </Col>
      </Row>
    </Card>
  );
};
